<template>
  <div>
    <template v-if="pattern=='model'">
      必填
      <Checkbox label="必填" v-model="content.must"></Checkbox>
      <Input style="width:100px" v-model="content.title" :disabled="$route.name!='approvalCreate'" placeholder="请输入标题"></Input>
    </template>
      <div style="display: inline-block;width:100px;text-align: right;vertical-align:middle;" v-else>{{content.title}}<span style="color: red" v-if="content.must">*</span></div>
    ：
    <template v-if="pattern!='handle'&&pattern!='forwarding'">
      <Input v-model="content.text" :disabled="pattern!='submission'" style="width:350px" placeholder="填写内容"></Input>
      <Icon class="close-icon" v-if="pattern=='model'" type="md-close-circle" @click="$emit('del',index)"></Icon>
    </template>
    <template v-else>
      <div style="display: inline-block">{{content.text}}</div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "approvalInput",//输入框
    props:{
      index:Number,
      pattern:String,
      contentIn:Object,
    },
    data:function () {
      return{
        content:{
          title:'',
          text:'',
          must:false,
          allowSubmission:false,
        },
      }
    },
    watch:{
      content:{
        handler(){
          if(this.content.must!=true||!this.isEmpty(this.content.text)){
            this.content.allowSubmission = true
          }else{
            this.content.allowSubmission = false
          }
          this.$emit('change',this.content)
        },
        deep:true,
        immediate:true,
      }
    },
    mounted:function () {
      if(this.contentIn.title!=undefined){
        this.content = this.contentIn
      }
    }
  }
</script>